import React, { useEffect, useState } from 'react'
import { ButtonDropdown, DropdownMenu, DropdownToggle } from 'reactstrap';
import { RadioContainer } from '../../commons';
import { CloseIcon, SwapGrayIcon, SwapIcon } from '../../../assets/images';


const RECRUITMENT_SORTING = [
    {
        id: "Recently Added/Modified First",
        name: "Recently Added/Modified First",
        value:""
    },
    {
        id: "Candidate Name - A to Z",
        _id:"name",
        name: "Candidate Name - A to Z",
        value:"1"
    },
    {
        id: "Candidate Name - Z to A",
        _id:"name",
        name: "Candidate Name - Z to A",
        value:"-1"
    },
    {
        id: "Experience - Ascending",
        _id:"years_of_experience",
        name: "Experience - Ascending",
        value:"1"
    },
    {
        id: "Experience - Descending",
        _id:"years_of_experience",
        name: "Experience - Descending",
        value:"-1"
    },
    {
        id: "Notice Period - Ascending",
        _id:"notice_period",
        name: "Notice Period - Ascending",
        value:"1"
    },
    {
        id: "Notice Period - Descending",
        _id:"notice_period",
        name: "Notice Period - Descending",
        value:"-1"
    },
   
]


type AppProps={
    toggle: boolean;
    setToggle: (data: boolean) => void;
    handleSorting: (data: any) => void;
    selectedData: { name: string, value: string}

}
const RecruitementSorting = ({
    toggle,
    setToggle,
    handleSorting,
    selectedData
}:AppProps) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [sortingData, setSortingData] = useState({ name: "", value: "" })
    useEffect(()=>{
        if(sortingData?.name){
           handleSorting(sortingData)
        }
        
    },[sortingData?.name])

    const handleRadioValue = (data: any) => {
        let selectedData=RECRUITMENT_SORTING?.filter((item:any)=>item?.id===data)
        setSortingData(selectedData[0])
        }

  return (
    <>
       <ButtonDropdown
            isOpen={toggle}
            toggle={() => {
                setToggle(!toggle)

            }}
        >

            <DropdownToggle
                caret
                color="secondary"
                style={
                    isOpen
                        ? {
                            color: "#dd4433",
                            border: "1px solid #dd4433",
                            backgroundColor: "#fff6f5",
                        }
                        : { border: "1px solid#bfcbe1" }
                }
                outline
            >
                {/* <img src={SwapIcon } alt="" /> */}
                <img src={selectedData?.value ? SwapIcon : SwapGrayIcon} alt="" />

            </DropdownToggle>

            <DropdownMenu right style={{ width: "340px", padding: '15px 15px 15px' }}>
                <div className='d-flex justify-content-between mt-0 mb-2'>
                <h5 className='text-start '>Sort</h5>

                    <div
                    className='pointer'
                        // style={{ padding: "8px" }}
                        onClick={() => {
                            // setIsOpen(!isOpen)
                            setToggle(!toggle)

                        }}
                        >
            <img src={CloseIcon} alt="" />
            </div>
            </div>
            <hr className='mt-0 mb-0' />
            <div className='row d-block p-3'>


                        <div>
                        <RadioContainer
                            optionsList={RECRUITMENT_SORTING}
                            handleSetRadioValue={handleRadioValue}
                            radioValue={selectedData?.name?selectedData?.name:"Recently Added/Modified First"}

                            alignment="vertical"
                            backGround={true}
                            
                        />
                        </div>
            </div>
                   
               
            </DropdownMenu>
        </ButtonDropdown>
      
    </>
  )
}

export default RecruitementSorting
